import React, { useState } from "react";
import LocationDeleteModal from "../../modals/LocationDeleteModal";
import { deleteGeoFenceData } from "../../../AxiosRtk/Location";

const Zones = ({ locationData, handleEdit, deleteLocationData, getLangTranslation }) => {
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState({});

  const closeModal = () => {
    setShowModal(false);
  };

  const handleDelete = (data) => {
    deleteGeoFenceData({ geofenceId: data?.id })
      .then((res) => {
        deleteLocationData(data);
        closeModal();
      })
      .catch((err) => {
        console.log("rating catch error ==>>", err?.response?.data?.message);
      });
  };
  return (
    <>
      <LocationDeleteModal
        showModal={showModal}
        closeModal={closeModal}
        data={data}
        handleDelete={handleDelete}
      />
      <div className="mt-6">
        {/* <h6 className="text-uppercase">{getLangTranslation("LOCATION_SETTINGS_CREATED_ZONES", "Created zones:")}</h6> */}
        {/* <p>Turpis massa scelerisque pellentesque feugiat.</p> */}
        <div className="row cursor-pointer">
          {locationData?.map((item) => (
            <div
              className="col-md-3"
              onClick={() => {
                handleEdit(item);
              }}
            >
              <div className="zone-item">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 me-3">
                    <h6 className="text-blue-900 mb-1">
                      {item?.geofence_name}
                    </h6>
                    <p className="text-gray text-small mb-0">
                      {getLangTranslation("SAFE_ZONE_RADIUS", "Radius")}: {item?.radius / 1000}
                      {item?.type == 1 ? "km" : "ml"}
                    </p>
                  </div>
                  <span
                    className="icon-wrap icon-blue"
                    onClick={(e) => {
                      e.stopPropagation();
                      setData(item);
                      setShowModal(true);
                    }}
                  >
                    <i className="icon-trash"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Zones;
